import { notEmpty, validateCheckingAccount, validateRoutingNumber } from '@common/paymentsUtils/inputValidator';
import errorMessages from '@common/constants/errorMessages';
import { trackValidationError } from '@common/actions/TrackingActions';

const accountConfirmationMatches = ({ checkingAccountNumber, confirmAccountNumber }) =>
  notEmpty(checkingAccountNumber) && notEmpty(confirmAccountNumber) && checkingAccountNumber === confirmAccountNumber;

export const validateBankInfo = (ctx) => {
  let { routingNumber, checkingAccountNumber, confirmAccountNumber } = ctx.state;
  const newState = ctx.state;
  const errors: Record<string, any> = [];

  routingNumber = routingNumber.value;
  checkingAccountNumber = checkingAccountNumber.value;
  confirmAccountNumber = confirmAccountNumber.value;

  if (!routingNumber) {
    const err = errorMessages.ROUTING_NUMBER_EMPTY;
    newState.routingNumber.error = err;
  } else if (routingNumber.length !== 9) {
    const err = errorMessages.ROUTING_NUMBER_INVALID;
    newState.routingNumber.error = err;
    errors.push(err);
  } else if (!validateRoutingNumber(routingNumber)) {
    const err = errorMessages.ROUTING_NUMBER_DEFAULT_ERROR;
    newState.routingNumber.error = err;
    errors.push(err);
  } else {
    newState.routingNumber.error = '';
  }

  if (!checkingAccountNumber) {
    const err = errorMessages.CHECKING_ACCOUNT_NUMBER_EMPTY;
    newState.checkingAccountNumber.error = err;
    errors.push(err);
  } else if (validateCheckingAccount(checkingAccountNumber) !== true) {
    const err = errorMessages.CHECKING_ACCOUNT_NUMBER_INVALID;
    newState.checkingAccountNumber.error = err;
    errors.push(err);
  } else {
    newState.checkingAccountNumber.error = '';
  }

  if (!confirmAccountNumber) {
    const err = errorMessages.CHECKING_ACCOUNT_NUMBER_CONFIRMATION_EMPTY;
    newState.confirmAccountNumber.error = err;
    errors.push(err);
  } else if (accountConfirmationMatches({ checkingAccountNumber, confirmAccountNumber }) !== true) {
    const err = errorMessages.CHECKING_ACCOUNT_NUMBER_CONFIRMATION_NOT_MATCH;
    newState.confirmAccountNumber.error = err;
    errors.push(err);
  } else {
    newState.confirmAccountNumber.error = '';
  }

  ctx.setState(newState);

  if (errors.length > 0) {
    trackValidationError({ errors });
    return false;
  }
  return true;
};
